import React, { useState, useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import axios from 'axios';
import DoctorProfilePage from './DoctorProfilePage';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function DoctorSlugResolver() {
  const { slug } = useParams();
  const [doctorId, setDoctorId] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    axios.get(`${API_URL}/api/public/resolve-slug/${slug}`)
      .then(res => setDoctorId(res.data.id))
      .catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) return <Navigate to="/" replace />;
  if (!doctorId) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary" />
      </div>
    );
  }

  return <DoctorProfilePage overrideId={doctorId} />;
}
